import styled, { css } from 'styled-components';
import { spaceL, spaceXL, spaceXXL, xdlColorPremiumTertiary, } from '@xingternal/tokens';
const BottomSheetContentContainer = styled.div `
  padding: ${spaceXL} ${spaceXXL} ${spaceXL} ${spaceXL};

  ${({ premiumTheme }) => premiumTheme &&
    css `
      background: ${xdlColorPremiumTertiary};
    `}

  & p:last-of-type {
    margin-bottom: ${spaceL};
  }
`;
export const Styled = {
    BottomSheetContentContainer,
};
//# sourceMappingURL=styles.js.map